import React from 'react';
import { number, shape, string } from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from './css/CurrentConditions.css';
import { FeatureFlagKey } from '../../types';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { convertDirection } from '../utils/compass';

const images = require.context('../images', true);
const newImages = require.context('../images/new', true);

export function CurrentConditions({
  dewPoint,
  humidity,
  temperature,
  weatherCondition,
  windDirection,
  windSpeed,
}) {

  const isSprayAssistEnabled = useFeatureFlag(FeatureFlagKey.DMB_SPRAY_ASSIST);
  const translateDirection = (angle) =>
    getMessage(`forecast.direction.${convertDirection(angle)}`);

  return (
    <div className={styles.container}
      data-test-id="current-conditions"
      data-spray-assist={isSprayAssistEnabled}
      style={isSprayAssistEnabled ? ({ borderBottom: 0, paddingBottom: 0 }) : ({})}
    >
      <div className={isSprayAssistEnabled ? styles.currentContainer : ({})}>
        <div className={styles.title}>
          {weatherCondition.data
            ? getMessage(
              `forecast.conditions.${weatherCondition.data}`
            ).toUpperCase()
            : getMessage('forecast.current.temp')}
        </div>
        <div className={isSprayAssistEnabled ? styles.valueSprayAssistFF : styles.value}>
          {weatherCondition.data && (
            <img
              alt={getMessage('image.weather.condition')}
              data-test-id="current-conditions-weather-icon"
              className={isSprayAssistEnabled ? styles.weatherIcon : styles.value}
              src={isSprayAssistEnabled
                ? newImages(
                  `./forecast-icons/medium/${weatherCondition.data.replace(
                    '_',
                    ''
                  )}.png`
                )
                : images(
                  `./forecast-icons/medium/${weatherCondition.data.replace(
                    '_',
                    ''
                  )}.png`
                )}
            />
          )}
          <div>{temperature}</div>
        </div>
      </div>
      <div className={isSprayAssistEnabled ? styles.currentContainer : ({})}>
        <div className={styles.title}>
          {getMessage('forecast.current.wind')}
        </div>
        {isSprayAssistEnabled ? (
          <div className={styles.valueSprayAssistFF}>
            <img
              alt={getMessage('image.compass.needle')}
              src={newImages('./forecast/wind_direction.png')}
              className={styles.weatherIcon}
              style={{ transform: `rotate(${windDirection.q}deg)` }}
            />
            <div>{`${translateDirection(windDirection.q + 180)} ${windSpeed}`}</div>
          </div>
        ) : (
          <div className={styles.value}>
            <div className={styles.compassContainer}>
              <img
                alt={getMessage('image.compass.background')}
                src={images('./forecast/wind_direction_bg.png')}
              />
              <img
                alt={getMessage('image.compass.needle')}
                className={styles.compassNeedle}
                src={images('./forecast/wind_direction_fg.png')}
                style={{ transform: `rotate(${windDirection.q}deg)` }}
              />
            </div>
            <div>{windSpeed}</div>
          </div>
        )}
      </div>
      <div className={isSprayAssistEnabled ? styles.currentContainer : ({})}>
        <div className={styles.title}>
          {getMessage('forecast.current.humidity')}
        </div>
        <div className={isSprayAssistEnabled ? styles.valueSprayAssistFF : styles.value}>
          <img
            alt={getMessage('image.humidity')}
            src={isSprayAssistEnabled
              ? newImages('./forecast/humidity.png')
              : images('./forecast/humidity.png')}
          />
          <div>{humidity}</div>
        </div>
      </div>
      <div className={isSprayAssistEnabled ? styles.currentContainer : ({})}>
        <div className={styles.title}>
          {getMessage('forecast.current.dewPoint')}
        </div>
        <div className={isSprayAssistEnabled ? styles.valueSprayAssistFF : styles.value}>
          <img
            alt={getMessage('image.dewPoint')}
            src={isSprayAssistEnabled
              ? newImages('./forecast/dew_point.png')
              : images('./forecast/new_dew_point.png')}
          />
          <div>{dewPoint}</div>
        </div>
      </div>
    </div>
  );
}

CurrentConditions.propTypes = {
  dewPoint: string,
  humidity: string,
  temperature: string,
  weatherCondition: shape({ data: string }),
  windDirection: shape({
    q: number,
    u: string,
  }),
  windSpeed: string,
};
